module.exports = __webpack_public_path__ + "static/img/Maple Oyster.b782550.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/color/Maple Oyster.jpg
// module id = 7q3c
// module chunks = 0